import { render } from "./placeholder-result.vue?vue&type=template&id=ca32301a&scoped=true"
import script from "./placeholder-result.vue?vue&type=script&lang=js"
export * from "./placeholder-result.vue?vue&type=script&lang=js"

import "./placeholder-result.vue?vue&type=style&index=0&id=ca32301a&lang=scss&scoped=true"

import exportComponent from "/var/www/webroot/master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca32301a"]])

export default __exports__